import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { MdCalendarToday, MdBookmarkBorder, MdLogout, MdMenu, MdClose } from 'react-icons/md';
import { HiOfficeBuilding } from 'react-icons/hi';
import './UserSidebar.css';

function UserSidebar() {
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    sessionStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userEmail');
    navigate('/signin');
  };

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <aside className={`user-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="logo-section">
          {isCollapsed ? (
            <div className="logo-icon-container">
              <img src="/corrohealth-logo.png" alt="CorroHealth" className="logo-icon-cropped" />
            </div>
          ) : (
            <img src="/corrohealth-logo.png" alt="CorroHealth" className="logo-full-img" />
          )}
          <button className="collapse-btn" onClick={toggleCollapse} title={isCollapsed ? "Expand" : "Collapse"}>
            {isCollapsed ? <MdMenu /> : <MdClose />}
          </button>
        </div>
        {!isCollapsed && (
          <div className="workspace-title">
            <HiOfficeBuilding className="workspace-icon" />
            <span>Workspace Booking</span>
          </div>
        )}
      </div>
      <nav>
        <ul className="menu">
          <li>
            <NavLink to="/user/book-room" className={({ isActive }) => isActive ? 'active' : undefined}>
              <span className="menu-icon"><MdCalendarToday /></span>
              <span>Book a Workspace</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/user/my-bookings" className={({ isActive }) => isActive ? 'active' : undefined}>
              <span className="menu-icon"><MdBookmarkBorder /></span>
              <span>My Bookings</span>
            </NavLink>
          </li>
        </ul>
      </nav>

      <div className="sidebar-footer">
        <button
          type="button"
          className="logout-btn"
          onClick={handleLogout}
        >
          <MdLogout />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}

export default UserSidebar;
